import { useEffect } from 'react'

import { deleteCustomer } from '@/apis/customers'
import CustomersPageHeader from '@/components/pages/Customer/List/PageHeader'
import CustomersTable from '@/components/pages/Customer/List/Table'
import { API_DEFAULT_PAGE, API_LIMIT } from '@/constants/api'
import { Customer } from '@/types'

import { useCustomers } from './Customers.hooks'

const Customers = () => {
  const { getCustomersLoading, getCustomersResponse, getCustomers } = useCustomers()

  const handleDeleteCustomer = async (id: Customer['id']) => {
    await deleteCustomer({ id })
    getCustomers({
      page: API_DEFAULT_PAGE,
      limit: API_LIMIT,
    })
  }

  useEffect(() => {
    getCustomers({
      page: API_DEFAULT_PAGE,
      limit: API_LIMIT,
    })
  }, [getCustomers])

  return (
    <>
      <CustomersPageHeader />
      <CustomersTable
        {...{
          dataSource: getCustomersResponse,
          getCustomersLoading,
        }}
        onDelete={handleDeleteCustomer}
        getCustomers={getCustomers}
      />
    </>
  )
}

Customers.displayName = 'Customers'
export default Customers
